import * as React from 'react';
import styled from "styled-components";
import moment from "moment";
import {ArticleCard} from "../components";

import BoosterImage from '../images/articles/article-booster.png';
import PurchaseImage from '../images/articles/article-purchase-conversion.png';
import DeliveryImage from '../images/articles/article-delivery-conversion.png';

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, 360px);
  gap: 40px;
  border-radius: 20px;
  margin: 0 auto;
  max-width: 1160px;
  opacity: 0;
  transition: opacity 1s;
`;

/**
 * render landing page main section
 * @constructor
 */
export default function Blog(): React.ReactElement {
  const ref = React.createRef<HTMLDivElement>();

  React.useEffect(() => {
    if (ref.current?.style) {
      ref.current.style.opacity = '1'
    }
  }, []);

  return (
    <Container ref={ref}>
      <ArticleCard
        created={moment('10.08.2021', 'DD.MM.YYYY')}
        previewSrc={BoosterImage}
        title="В 3 раза ускоряет создание и продажи онлайн курсов "
        shortDescription="в 10 раз при использовании обычных CMS "
      />
      <ArticleCard
        created={moment('10.08.2021', 'DD.MM.YYYY')}
        previewSrc={PurchaseImage}
        title="50% в среднем выше конверсия в покупку"
        shortDescription="Промо, upsale, cross-sell, OTO и другие инструменты 2 в клика"
      />
      <ArticleCard
        created={moment('10.08.2021', 'DD.MM.YYYY')}
        previewSrc={DeliveryImage}
        title="Самая высокая конверсия в доставку"
        shortDescription="Веб-приложение, на акутальных технолгиях, одинаково великолепно работает на любом устройстве"
      />
    </Container>
  );
}
